// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body[data-v-b80ca3e4],html[data-v-b80ca3e4]{scroll-behavior:smooth}", ""]);
// Exports
module.exports = exports;
